import { CustomerType, MandatiMago } from './customer';
import { ProductCode } from './industry';

export class AdministrativeInfo {
    CompanyCode: string; //può essere il codice utente di pai o il codice rivenditore
    CompanyName: string; //ragione sociale
    EMail: string;
    CompanyType: number; // enumerativo che identifica il tipo azienda cliente 36700161 o rivenditore 36700160
    Country: string;
    Region: string;
    County: string;
    Disabled: boolean;
    CustomerStatus: number;
    Subscribed: string;
    Division: number;
    ValidationToken: string;
    CompanyNameCompact: string;
    ProductCode: string;
    Name: string;
    Surname: string;
    IsEmployee: boolean;
    IsAreaManager: boolean;
    MCPType: string;
    Mandato: string;
    CustSupp: string;
    ZucchettiGroup: string;
    ResellerAssigned: string;
    IsBetatester: boolean;
}

export class AdministrativeInfoContainer {
    public static isReseller(administrativeInfo: AdministrativeInfo[]) {
        if (!administrativeInfo) return false;
        return administrativeInfo.find((x) => x.CompanyType == CustomerType.Rivenditore);
    }

    public static isResellerAndHasMagoCloudContract(administrativeInfo: AdministrativeInfo[]) {
        if (!administrativeInfo) return false;
        let MagoCloudContract = administrativeInfo.find(
            (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOCLD
        );
        return MagoCloudContract;
    }
    public static isResellerAndHasMagoWebContract(administrativeInfo: AdministrativeInfo[]) {
        if (!administrativeInfo) return false;
        let MagoWebContract = administrativeInfo.find(
            (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOWEB
        );
        return MagoWebContract;
    }

    public static isResellerAndHasMago4Contract(administrativeInfo: AdministrativeInfo[]) {
      if (!administrativeInfo) return false;
      let Mago4Contract = administrativeInfo.find(
          (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGO4
      );
      return Mago4Contract;
  }
  public static isPlatinumPartner(listOfMandati: Map<string, string>, productCode:string) {
    if (!listOfMandati || listOfMandati.size == 0) return false;
        return listOfMandati.get(productCode) == MandatiMago.PLATINUM;
    }
    public static isGoldPartner(listOfMandati: Map<string, string>, productCode:string) {
      if (!listOfMandati || listOfMandati.size == 0) return false;
      return listOfMandati.get(productCode) == MandatiMago.GOLD;
    }
    public static isSilverPartner(listOfMandati: Map<string, string>, productCode:string) {
      if (!listOfMandati || listOfMandati.size == 0) return false;
      return listOfMandati.get(productCode) == MandatiMago.SILVER;
    }


    public static isBranch(administrativeInfo: AdministrativeInfo) {
        if (!administrativeInfo) return false;
        return administrativeInfo.ZucchettiGroup == '1';
    }

    //21/02/2022 Mario A. ha detto che per ora possono vedere la sezione solo i partner Excellence
    public static CanSeeOnPremiseSection(companyInfo: AdministrativeInfo) {
        // con l'uscita di MagoWeb non sarà più possibile acquistare una on premises
        return false;
        // (
        //     AdministrativeInfoContainer.isExcellencePartner(companyInfo) ||
        //     //|| AdministrativeInfoContainer.isPremiumPartner(companyInfo)
        //     AdministrativeInfoContainer.isBranch(companyInfo)
        // );
    }
}
